import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'
import { ProductChangeOversTable } from 'Features/Projects/Scenarios/EditSettings/LineSettings/Changeovers.Table'
import { useProductChangeovers } from './LineSettings.data'
import { useParams } from 'react-router-dom'
import { Loader } from 'Common/Loader/Loader'
import { EditSettingsDataFilter } from '../EditSettings.DataFilter'
import { useSettingsContext } from '../EditSettings.types'
import { useMemo } from 'react'

export const ChangeoversView = () => {
  const { view_width, view_height } = useWindowSize()
  const { projectId, scenarioId } = useParams() as {
    projectId: string
    scenarioId: string
  }

  const { state } = useSettingsContext()
  const { selectedBaseSourceSite, selectedWorkCentre } = state

  const { data: productChangeoverData, isLoading } = useProductChangeovers({
    projectId,
    scenarioId,
  })

  const filteredChangeoverData = useMemo(() => {
    if (!productChangeoverData) return []
    
    let filtered = productChangeoverData
    
    // Filter by baseSourceSite
    if (selectedBaseSourceSite && selectedBaseSourceSite !== 'All') {
      filtered = filtered.filter(
        (item) => item.baseSourceSiteCode === selectedBaseSourceSite
      )
    }
    
    // Filter by workCentre  
    if (selectedWorkCentre && selectedWorkCentre !== 'All') {
      filtered = filtered.filter(
        (item) => item.workcentreCode === selectedWorkCentre
      )
    }
    
    return filtered
  }, [productChangeoverData, selectedBaseSourceSite, selectedWorkCentre])

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader
          title="Changeovers"
          rightElement={<EditSettingsDataFilter />}
        />
        {isLoading ? (
          <Loader />
        ) : (
          <ProductChangeOversTable
            data={filteredChangeoverData}
            isLoading={isLoading}
          />
        )}
      </Box>
    </Page>
  )
}
